module.exports = __webpack_public_path__ + "img/4.981d28cb.png";